import { reducer, actions } from "@grandvisionhq/state";
import { updateActiveVariant, updatePurchaseType } from "./actions.js";
import { SINGLE_PURCHASE } from "../../types/types/purchase-types.js";
const initialState = {
  activeSku: "",
  selectedPurchaseType: SINGLE_PURCHASE
};
const productDetailContextReducer = reducer(
  initialState,
  actions.on(updateActiveVariant, (state, action) => ({
    ...state,
    activeSku: action.payload.sku
  })),
  actions.on(updatePurchaseType, (state, action) => ({
    ...state,
    selectedPurchaseType: action.payload.purchaseType
  }))
);
export {
  initialState,
  productDetailContextReducer
};
//# sourceMappingURL=reducer.js.map
